import { USER_LIST_REQUEST } from "../actions/utilities";
const INITIAL_STATE = {
    userListLoading: false,
    userListSuccess: false,
    userListFailure: false,
    userListError: null,
    userList: []
}

export const userListReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case USER_LIST_REQUEST.GET_USER_REQUEST:
            return {
                ...state,
                userListLoading: true,
                userListSuccess: false,
                userListFailure: false,
                userListError: null,
                userList: []
            }
        case USER_LIST_REQUEST.GET_USER_SUCCESS:
            return {
                ...state,
                userListLoading: false,
                userListSuccess: true,
                userListFailure: false,
                userListError: null,
                userList: action.payload
            }
        case USER_LIST_REQUEST.GET_USER_FAILURE:
            return {
                ...state,
                userListLoading: false,
                userListSuccess: false,
                userListFailure: true,
                userListError: action.payload
            }
        case "submit":
            // console.log(state, "newdata");
            state.userList = [...state.userList, action.payload];
            return {
                ...state
            }
        case "edit":
            var list = []
            for (var i =0; i < state.userList.length; i++){
                list.push(state.userList[i]);
                if (state.userList[i]["id"]=== action.payload.id){
                    list[i]["isBlocked"]= action.payload.value;
                }
            }
            
            return {
                ...state,
                userList: list
            }
        default:
            return state;
    }
}